import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, InputAdornment } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CheckBox from "../../components/Form/CheckBox";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import RadioButtonGroupInGrid from "../../components/Form/RadioButtonGroupInGrid";
import { createBanner, getBannerDetails, resetBannerState, updateBanner, } from "../../store/actions";
import "../Orders/order.css";
import "../Vouchers/voucher.css";
import Helpers from "../../helpers/helpers";
import CustomSelect from "../../components/Form/CustomSelect";


const AddBanner = ({ title, type, bannerDetails, editBanner, addBanner, errorBanner, userPermission }) => {
    const { ID } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fileInputRef = useRef();
    const mobileFileInputRef = useRef();

    useEffect(() => {
        if (userPermission?.length > 0) {
            // !userPermission?.includes("view-marketing") && navigate('/not-authorized');
        }
    }, [userPermission])

    const defaultValues = {
        type: "static",
        url: "",
        desktopImg: "",
        mobileImg: "",
        startDate: null,
        endDate: null,
        status: "1",
        sortOrder: "",
        position: "",
        bannerTitle: "",
        bannerLabel: "",
        bannerDescription: "",
        cta: "",
        ctaText: ""
    }
    const [loading, setIsLoading] = useState(false);
    const [isNoEndDate, setIsNoEndDate] = useState(false);
    const [values, setFormValues] = useState(defaultValues);
    const [error, setError] = useState();
    const [width, setWidth] = useState(window.innerWidth);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const statusList = [
        { label: "Active", value: "1" },
        { label: "Inactive", value: "0" },
    ]

    const positionList = [
        { label: "HOME_TOP (Main hero section)", value: "HOME_TOP" },
        { label: "HOME_BANNER", value: "HOME_BANNER" },
        { label: "HOME_POPUP (Appears as a modal)", value: "HOME_POPUP" },
    ]

    const configurablePositionList = [
        { label: "HOME_BANNER", value: "HOME_BANNER" },
    ]

    const bannerTypeList = [
        { label: "Static", value: "static" },
        { label: "Configurable", value: "configurable" },
    ]

    const handleSubmit = async (type) => {
        let payload = {};
        setIsLoading(true);
        if (values?.type === "static") {
            payload = {
                type: values?.type || '',
                position: values?.position || '',
                image: values?.desktopImg || '',
                mobile_image: values?.mobileImg || '',
                url: values?.url || '',
                sort_order: values?.sortOrder || '',
                status: values?.status,
                show_button: values?.cta || 0,
                has_daterange: isNoEndDate ? 0 : 1,
                start: values?.startDate || '',
                end: values?.endDate || '',
            }
        } else {
            payload = {
                type: values?.type || '',
                position: values?.position || '',
                image: values?.desktopImg || '',
                mobile_image: values?.mobileImg || '',
                url: values?.url || '',
                sort_order: values?.sortOrder || '',
                status: values?.status,
                show_button: values?.cta || 0,
                has_daterange: isNoEndDate ? 0 : 1,
                start: values?.startDate || '',
                end: values?.endDate || '',
                title: values?.bannerTitle || '',
                label: values?.bannerLabel || '',
                button_label: values?.ctaText || '',
                description: values?.bannerDescription || '',
            }
        }
        if (type === "Add") {
            const filteredValues = Object.fromEntries(
                Object.entries(payload).filter(([key, value]) => value !== "")
            );
            dispatch(createBanner(filteredValues))
        }
        else if (type === "Edit") {
            if (values?.desktopImg) {
                payload.image = await handleImageSubmit(values?.desktopImg)
            }
            if (values?.mobileImg) {
                payload.mobile_image = await handleImageSubmit(values?.mobileImg)
            }
            const filteredValues = Object.fromEntries(
                Object.entries(payload).filter(([key, value]) => value !== "")
            );
            dispatch(updateBanner({ id: ID, banner: filteredValues }))
        }

    }

    const handleImageSubmit = async (imgUrl) => {
        let imageBase64 = '';
        const convertImage = (img) => {
            return new Promise((resolve) => {
                Helpers.imageToBase64Sync(img, (base64) => {
                    imageBase64 = base64;
                    resolve();
                });
            });
        };
        await convertImage(imgUrl)
        return imageBase64;
    }

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                dispatch(getBannerDetails({ id: ID }))
            }
        }

        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (type === "Edit") {
            if (ID) {
                const filtered = bannerDetails || []
                if (filtered) {
                    let payload = {
                        type: filtered?.type || '',
                        url: filtered?.url || '',
                        desktopImg: filtered?.image || '',
                        mobileImg: filtered?.mobile_image || '',
                        startDate: filtered?.start_at || null,
                        endDate: filtered?.end_at || null,
                        status: filtered.status,
                        sortOrder: filtered?.sort_order === 0 ? '0' : filtered?.sort_order || '',
                        position: filtered?.position || '',
                        bannerTitle: filtered?.description?.title || '',
                        bannerLabel: filtered?.description?.label || '',
                        bannerDescription: filtered?.description?.description || '',
                        cta: filtered?.show_button || '0',
                        ctaText: filtered?.description?.button_label || '',
                    }
                    setFormValues(payload);
                    setIsNoEndDate(filtered?.has_daterange === 1 ? false : true)
                }
            }
        }
    }, [bannerDetails]);

    useEffect(() => {
        if (type === "Edit") {
            if (editBanner?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Updated Successfully",
                    type: "success",
                })
                dispatch(resetBannerState())
                dispatch(getBannerDetails({ id: ID }))
                setError("")
            } else if (editBanner?.code === "invalid_field") {
                setNotification({
                    open: true,
                    msg: "Please fill all the required fields",
                    type: "error",
                });
                setError(editBanner?.errors);
            }
            else if (editBanner?.code === "invalid_field") {
                setNotification({
                    open: true,
                    msg: "Please fill all the required fields",
                    type: "error",
                });
                setError(editBanner?.errors);
            }
            setIsLoading(false);
        }
    }, [editBanner]);

    useEffect(() => {
        if (type === "Add") {
            if (addBanner?.code === "success") {
                setNotification({
                    open: true,
                    msg: "Added Successfully",
                    type: "success",
                })
                dispatch(resetBannerState());
                setError("")
                navigate("/banners");
            }
            else if (addBanner?.code === "invalid_field") {
                setNotification({
                    open: true,
                    msg: "Please fill all the required fields.",
                    type: "error",
                });
                setError(addBanner?.errors);
            }
            setIsLoading(false);
        }
    }, [addBanner]);

    const handleValueChange = (key, value) => {
        if (value === "0") {
            setFormValues((prevValues) => ({
                ...prevValues,
                [key]: "0"
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [key]: value
            }));
        }
    };

    const onChangeDesktopFile = (file) => {
        if (Helpers.isFileSizeValid(file, 5)) {
            Helpers.getPreviewBase64(file, (result) => {
                handleValueChange('desktopImg', result);
            });
        } else {
            setNotification({
                open: true,
                msg: "File size should be less than 1MB",
                type: "error",
            });
        }
        // Clear the upload file value
        fileInputRef.current.value = '';
    };

    const onChangeMobileFile = (file) => {
        if (Helpers.isFileSizeValid(file, 5)) {
            Helpers.getPreviewBase64(file, (result) => {
                handleValueChange('mobileImg', result);
            });
        } else {
            setNotification({
                open: true,
                msg: "File size should be less than 5MB",
                type: "error",
            })
        }
        // Clear the upload file value
        mobileFileInputRef.current.value = '';
    };

    const renderBasicInfoForm = () => {
        return (
            <Card className="p-3 px-2">
                <CardBody>
                    <div className="setting-header">ABOUT</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <RadioButtonGroupInGrid
                                title={'Type'}
                                value={values.type}
                                data={bannerTypeList}
                                setValue={(e) => {
                                    handleValueChange('type', e);
                                    if (e === 'configurable') handleValueChange('position', 'HOME_BANNER')
                                }}
                                required="true"
                                name="type"
                            />
                            {error?.type?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.type[0] || ""}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <CustomSelect
                                title={'Position'}
                                values={values?.position || '-1'}
                                onChange={(e) => handleValueChange('position', e)}
                                data={values?.type === 'configurable' ? configurablePositionList : positionList}
                                placeholder={'Please select'}
                            />
                            {error?.position?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.position[0] || ""}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={12} container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <CustomizedDatePicker
                                    title={'Start on'}
                                    values={values?.startDate && new Date(values?.startDate)}
                                    setFormValues={(e) => handleValueChange('startDate', e)}
                                />
                                {error?.start?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.start[0] || ""}</FormHelperText>}
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <CustomizedDatePicker
                                    title={'Ends on'}
                                    values={values?.endDate && new Date(values?.endDate)}
                                    setFormValues={(e) => handleValueChange('endDate', e)}
                                    disabled={isNoEndDate}
                                />
                                {error?.end?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.end[0] || ""}</FormHelperText>}
                            </Grid>
                            <Grid item xs={12} sm={4} className="d-flex align-items-end">
                                <CheckBox
                                    label={'No end date'}
                                    values={isNoEndDate}
                                    onChange={(e) => { setIsNoEndDate(e.target.checked); handleValueChange('endDate', ""); handleValueChange('has_end_date', 0) }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomTextField
                                title={'Banner link (Optional)'}
                                values={values?.url}
                                onChange={(e) => handleValueChange('url', e)}
                                type={'text'}
                                placeholder="eg., https://example.com"
                                subtitle={'Opens when banner is clicked.'}
                            />
                            {error?.url && <FormHelperText sx={{ color: "red" }}>{error.url[0]}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12}>Desktop Image ({values?.desktopImg ? '1' : '0'}/1)</Grid>
                        <Grid item xs={12} sm={12} display={'flex'} mb={1}>
                            <div>
                                {
                                    values?.desktopImg ?
                                        <img src={values?.desktopImg && `${values?.desktopImg}`} alt="desktop-image" style={{ height: '100%', width: 80, objectFit: "contain" }} /> :
                                        <div className="empty-image-container"><i className="ri-image-2-fill" style={{ color: '#D0D0D0', fontSize: 40 }} /></div>
                                }
                            </div>
                            <div className="mb-2 mx-3">
                                <CustomButton
                                    title={'Choose'}
                                    press={() => document.getElementById("new-upload-file").click()}
                                    backgroundColor={'#F2F2F2'}
                                    textColor={'#101010'}
                                    borderStyle={'1px solid #E3E8EE'}
                                />
                                {
                                    values?.desktopImg &&
                                    <CustomButton
                                        title={'Remove'}
                                        press={() => (handleValueChange('desktopImg', ""))}
                                        backgroundColor={'white'}
                                        textColor={'#101010'}
                                        borderStyle={'1px solid #E3E8EE'}
                                        marginLeft={5}
                                    />
                                }
                                <input
                                    type="file"
                                    id={"new-upload-file"}
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    accept="image/png, image/jpeg"
                                    onChange={(e) => onChangeDesktopFile(e.target.files[0])}
                                />
                                <div className="setting-desc mt-2">JPG or PNG, 5MB Max.</div>
                                <div className="setting-desc mt-2">Recommended resolution: 2560 x 800 for HOME_TOP and HOME_BANNER</div>
                            </div>
                        </Grid>
                        {error?.image && <FormHelperText sx={{ color: "red", marginLeft: 2 }}>{error.image[0]}</FormHelperText>}
                        <Grid item xs={12}>Mobile Image ({values?.mobileImg ? '1' : '0'}/1)</Grid>
                        <Grid item xs={12} sm={12} display={'flex'}>
                            <div>
                                {
                                    values?.mobileImg ?
                                        <img src={values?.mobileImg && `${values?.mobileImg}`} alt="desktop-image" style={{ height: '100%', width: 80, objectFit: "contain" }} /> :
                                        <div className="empty-image-container"><i className="ri-image-2-fill" style={{ color: '#D0D0D0', fontSize: 40 }} /></div>
                                }
                            </div>
                            <div className="mb-2 mx-3">
                                <CustomButton
                                    title={'Choose'}
                                    press={() => document.getElementById("new-upload-mobile-file").click()}
                                    backgroundColor={'#F2F2F2'}
                                    textColor={'#101010'}
                                    borderStyle={'1px solid #E3E8EE'}
                                />
                                {
                                    values?.mobileImg &&
                                    <CustomButton
                                        title={'Remove'}
                                        press={() => (handleValueChange('mobileImg', ""))}
                                        backgroundColor={'white'}
                                        textColor={'#101010'}
                                        borderStyle={'1px solid #E3E8EE'}
                                        marginLeft={5}
                                    />
                                }
                                <input
                                    type="file"
                                    id={"new-upload-mobile-file"}
                                    ref={mobileFileInputRef}
                                    style={{ display: 'none' }}
                                    accept="image/png, image/jpeg"
                                    onChange={(e) => onChangeMobileFile(e.target.files[0])}
                                />
                                <div className="setting-desc mt-2">JPG or PNG, 5MB Max.</div>
                            </div>
                        </Grid>
                        {error?.mobile_image?.length > 0 && <FormHelperText sx={{ color: "red", marginLeft: 2 }}>{error.mobile_image[0]}</FormHelperText>}
                    </Grid>
                </CardBody>
            </Card>
        )
    }

    const renderBannerContentDetailsForm = () => {
        return (
            <Card className="p-3 px-2 mt-3">
                <CardBody>
                    <div className="setting-header">BANNER CONTENT</div>
                    <Divider className="my-2 mb-4" />
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <CustomTextField
                                title={'Banner Title'}
                                values={values?.bannerTitle}
                                onChange={(e) => handleValueChange('bannerTitle', e)}
                                type={'text'}
                                placeholder="Banner title for this banner"
                            />
                            {error?.bannerTitle?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error?.bannerTitle[0] || ''}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <CustomTextField
                                title={'Label (Optional)'}
                                values={values?.bannerLabel}
                                onChange={(e) => handleValueChange('bannerLabel', e)}
                                type={'text'}
                                placeholder=" e.g., 'Limited Time Offer'"
                                subtitle={"Short label appearing above title."}
                            />
                            {error?.bannerLabel?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error?.bannerLabel[0] || ''}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <CustomTextField
                                title={'Description (Optional)'}
                                values={values?.bannerDescription}
                                onChange={(e) => handleValueChange('bannerDescription', e)}
                                type={'text'}
                                placeholder="Short description for this banner"
                                subtitle={"Short description appearing below title."}
                            />
                            {error?.bannerDescription?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error?.bannerDescription[0] || ''}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={6} className="d-flex align-items-end">
                            <RadioButtonGroupInGrid
                                title={'Show Call-to-Action (CTA) Button?'}
                                value={values.cta}
                                data={[{ label: "Yes", value: "1" }, { label: "No", value: "0" }]}
                                setValue={(e) => { if (e === "0") { handleValueChange('ctaText', null) }; handleValueChange('cta', e) }}
                                required="true"
                                name="cta"
                            />
                        </Grid>
                        {
                            (values?.cta === "1" || values?.cta === 1) &&
                            <Grid item xs={12} sm={6} className="d-flex align-items-end">
                                <CustomTextField
                                    title={'CTA Button Text'}
                                    values={values?.ctaText}
                                    onChange={(e) => handleValueChange('ctaText', e)}
                                    type={'text'}
                                    placeholder=" e.g., “Shop Now”"
                                />
                                {error?.ctaText?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error?.ctaText[0] || ''}</FormHelperText>}
                            </Grid>
                        }
                    </Grid>
                </CardBody>
            </Card>
        )
    }

    const renderSettingForm = () => {
        return (
            <Card className="p-3 px-2">
                <CardBody>
                    <div className="setting-header">SETTINGS</div>
                    <Divider className="my-2 mb-4" />
                    <div className="mt-3 mb-2">
                        <RadioButtonGroupInGrid
                            title={'Status'}
                            value={values.status || '0'}
                            data={statusList}
                            setValue={(e) => handleValueChange('status', e)}
                            required="true"
                            name="status"
                        />
                        {error?.status && <FormHelperText sx={{ color: "red" }}>{error.status[0] || ""}</FormHelperText>}
                    </div>
                    <CustomTextField
                        title={'Sort Order'}
                        values={`${values?.sortOrder}`}
                        onChange={(e) => handleValueChange('sortOrder', e)}
                        placeholder={'0'}
                        type={'phone'}
                        error={error?.sort_order?.[0]}
                    />
                </CardBody>
            </Card>
        )
    }
    return (
        <React.Fragment>
            {
                width <= 425 &&
                <div className="mobile-button-container">
                    <CustomButton
                        title={type === 'Add' ? 'Save' : 'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        width={'100%'}
                    />
                </div>
            }
            <div className="page-content">
                <LoadingDialog open={loading || (type === "Edit" && !bannerDetails?.id)} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={"/banners"}
                        breadcrumbItems={[{ title: "Banner", link: "/banners" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {
                            width > 425 &&
                            <CustomButton
                                title={type === 'Add' ? 'Save' : 'Save Changes'}
                                press={() => handleSubmit(type)}
                                height={40}
                                backgroundColor={'#101010'}
                                textColor={'white'}
                            />
                        }
                    </Breadcrumbs>
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} pb={3}>
                            {renderBasicInfoForm()}
                            {values?.type === "configurable" && renderBannerContentDetailsForm()}
                        </Grid>
                        <Grid container item sm={12} lg={4}>
                            <Grid item xs={12} sm={12}>
                                {renderSettingForm()}
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, Login, Banner }) {
    return {
        bannerDetails: Banner.bannerDetails,
        roleList: General.roleList,
        addBanner: Banner.addBanner,
        editBanner: Banner.updateBanner,
        errorBanner: Banner.error,
        attachment: General.attachment,
        categoryListing: General.categories,
        userPermission: Login.permissionArry,
        productListing: General.products,
    };
}


export default connect(mapStateToProps)(AddBanner);
